export const constcenter1 = [
  { id: "714", label: "Post Outsourcing", accountNumber: "70175", value: "714" },
  { id: "715", label: "Virtual Production-Operator", accountNumber: "70155", value: "715" },
  { id: "716", label: "Videograf", accountNumber: "70145", value: "716" },
  { id: "717", label: "Foto Still", accountNumber: "70110", value: "717" },
  { id: "718", label: "Styling Still", accountNumber: "70111", value: "718" },
  { id: "719", label: "Foto Life", accountNumber: "70120", value: "719" },
  { id: "720", label: "Styling Life", accountNumber: "70121", value: "720" },
  { id: "721", label: "Foto-Assistenz Life", accountNumber: "70122", value: "721" },
  { id: "722", label: "Models", accountNumber: "70124", value: "722" },
  { id: "723", label: "Hair & Make up", accountNumber: "70130", value: "723" },
  { id: "724", label: "Art Direction", accountNumber: "70160", value: "724" },
  { id: "725", label: "Post Production", accountNumber: "70170", value: "725" },
  { id: "726", label: "Text", accountNumber: "70180", value: "726" },
  { id: "727", label: "Sonstiges Produktion", accountNumber: "70190", value: "727" },
  { id: "728", label: "Verpflegung Shooting", accountNumber: "70193", value: "728" },
  { id: "729", label: "Producing", accountNumber: "70230", value: "729" },
  { id: "730", label: "Modelbooking", accountNumber: "70240", value: "730" },
  { id: "731", label: "Art Buying", accountNumber: "70250", value: "731" },
  { id: "732", label: "Logistik/Warenaufbereitung", accountNumber: "70260", value: "732" },
  { id: "733", label: "Technical Support", accountNumber: "70270", value: "733" },
  { id: "734", label: "Setbau", accountNumber: "70280", value: "734" },
  { id: "735", label: "Account Management", accountNumber: "70320", value: "735" },
  { id: "736", label: "Sales/Marketing", accountNumber: "70440", value: "736" },
  { id: "737", label: "IT/Technik", accountNumber: "70450", value: "737" },
  { id: "739", label: "Still Operator", accountNumber: "70115", value: "739" },
  { id: "845", label: "Digital Operator", accountNumber: "70150", value: "845" },
  { id: "860", label: "AI Content Production", accountNumber: "70199", value: "860" },
  { id: "863", label: "Development", accountNumber: "70470", value: "863" },
  { id: "866", label: "Videoproducing", accountNumber: "70140", value: "866" },
  { id: "872", label: "3D Artist", accountNumber: "70151", value: "872" },
];

export const constcenter2 = [
  { id: "738", label: "Kunden-übergreifend / Sonstiges", accountNumber: "709005", value: "738" },
  { id: "846", label: "Zalando zCreator", accountNumber: "705228", value: "846" },
  { id: "740", label: "S.Oliver Produktfoto", accountNumber: "700021", value: "740" },
  { id: "741", label: "Comma Produktfoto", accountNumber: "700031", value: "741" },
  { id: "742", label: "Liebeskind Produktfoto", accountNumber: "700041", value: "742" },
  { id: "743", label: "Marco Polo Kampagne/AI", accountNumber: "700051", value: "743" },
  { id: "744", label: "PUMA Produktfoto", accountNumber: "700061", value: "744" },
  { id: "745", label: "PUMA Kampagne", accountNumber: "700062", value: "745" },
  { id: "746", label: "TomTailor Produktfoto", accountNumber: "700071", value: "746" },
  { id: "747", label: "TomTailor Kamagne", accountNumber: "700072", value: "747" },
  { id: "748", label: "BonPrix Produktfoto", accountNumber: "700091", value: "748" },
  { id: "749", label: "HFG Produktfoto", accountNumber: "700101", value: "749" },
  { id: "750", label: "HFG Kampagne", accountNumber: "700102", value: "750" },
  { id: "751", label: "Juvia Produktfoto", accountNumber: "700111", value: "751" },
  { id: "752", label: "HugoBoss Produktfoto", accountNumber: "700121", value: "752" },
  { id: "753", label: "HugoBoss Kampagne", accountNumber: "700122", value: "753" },
  { id: "754", label: "Bogner Produktfoto", accountNumber: "700601", value: "754" },
  { id: "755", label: "Bogner Kampagne", accountNumber: "700602", value: "755" },
  { id: "756", label: "Heine Produktfoto", accountNumber: "700621", value: "756" },
  { id: "757", label: "WittWeiden Produktfoto", accountNumber: "705071", value: "757" },
  { id: "758", label: "Zalando EPS Produktfoto", accountNumber: "705141", value: "758" },
  { id: "759", label: "Zalando EPS Kampagne", accountNumber: "705142", value: "759" },
  { id: "760", label: "ToryBurch Produktfoto", accountNumber: "705171", value: "760" },
  { id: "761", label: "Falke Produktfoto", accountNumber: "705181", value: "761" },
  { id: "762", label: "Zalando RPDP Produktfoto", accountNumber: "705221", value: "762" },
  { id: "763", label: "Sonstige Kleinkunden Produktfoto", accountNumber: "707991", value: "763" },
  { id: "766", label: "PUMA Virtual Production", accountNumber: "700066", value: "766" },
  { id: "767", label: "C&A Produktfoto", accountNumber: "703421", value: "767" },
  { id: "768", label: "C&A Kampagne", accountNumber: "740022", value: "768" },
  { id: "769", label: "C&A Virtual Production", accountNumber: "740029", value: "769" },
  { id: "773", label: "Ziener Produktfoto", accountNumber: "705051", value: "773" },
  { id: "772", label: "Zalando EPDP Produktfoto HH", accountNumber: "705191", value: "772" },
  { id: "776", label: "Douglas Produktfoto", accountNumber: "740211", value: "776" },
  { id: "777", label: "Douglas Kampagne", accountNumber: "740212", value: "777" },
  { id: "778", label: "Tommy Hilfiger Produktfoto", accountNumber: "740411", value: "778" },
  { id: "779", label: "Peter Schmidt Group Produktfoto HH", accountNumber: "705061", value: "779" },
  { id: "847", label: "z PDP ACC", accountNumber: "705230", value: "847" },
  { id: "848", label: "Mammut PF HH", accountNumber: "700551", value: "848" },
  { id: "856", label: "TB International PF HH", accountNumber: "700451", value: "856" },
  { id: "849", label: "DEV - AI Character Creation", accountNumber: "709510", value: "849" },
  { id: "850", label: "DEV - AI Character Replacement", accountNumber: "709512", value: "850" },
  { id: "851", label: "DEV - AI Background Creation", accountNumber: "709514", value: "851" },
  { id: "852", label: "DEV - AI Background Replacement", accountNumber: "709516", value: "852" },
  { id: "854", label: "DEV - Bust to on-Model", accountNumber: "709520", value: "854" },
  { id: "855", label: "DEV - AI Content Hub", accountNumber: "709522", value: "855" },
  { id: "861", label: "DEV - KIND", accountNumber: "709524", value: "861" },
  { id: "858", label: "New Production Line", accountNumber: "706010", value: "858" },
  { id: "862", label: "sonstige Kleinkunden Social Media HH", accountNumber: "707994", value: "862" },
  { id: "864", label: "Akquise Kampagne", accountNumber: "708002", value: "864" },
  { id: "865", label: "Akquise Sonstiges", accountNumber: "708005", value: "865" },
  { id: "853", label: "DEV - Image to AI-Video", accountNumber: "709518", value: "853" },
  { id: "867", label: "Marco Polo Produktfoto HH", accountNumber: "700052", value: "867" },
  { id: "868", label: "Closed Produktfoto HH", accountNumber: "700036", value: "868" },
  { id: "869", label: "Closed Kampagne/AI", accountNumber: "700038", value: "869" },
  { id: "870", label: "Tommy Hilfiger Produktfoto HH", accountNumber: "700411", value: "870" },
  { id: "871", label: "Tommy Hilfiger Kampagne/AI", accountNumber: "700412", value: "871" },
    { id: "873", label: "CGI Nordason", accountNumber: "740094", value: "873" },

];
